module.exports = __WEBPACK_EXTERNAL_MODULE_99__;


//////////////////
// WEBPACK FOOTER
// external "vue"
// module id = 99
// module chunks = 0